import { ChevronDown, Plus } from 'lucide-react';
import { workItemTypeLabel, WORK_ITEM_TYPES, type WorkItemType } from '../../lib/work-types';
import { Button } from '../ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { useOverlays } from './overlay-context';

export default function NewWorkItemMenu({
  projectId,
  label = 'New item',
  primaryType,
}: {
  projectId?: string;
  label?: string;
  /** Makes the button create this type straight away; the arrow beside it keeps the other types. */
  primaryType?: WorkItemType;
}) {
  const { openCreateWorkItem } = useOverlays();
  const types = WORK_ITEM_TYPES.filter((type) => type !== 'initiative');

  if (primaryType) {
    const others = types.filter((type) => type !== primaryType);
    return (
      <div className="inline-flex rounded-md shadow-sm">
        <Button
          type="button"
          size="sm"
          className="gap-1.5 rounded-r-none"
          onClick={() => openCreateWorkItem({ projectId, type: primaryType })}
        >
          <Plus className="h-4 w-4" aria-hidden />
          {label}
        </Button>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              type="button"
              size="sm"
              className="rounded-l-none border-l border-primary-foreground/25 px-2"
              aria-label="Create something else"
            >
              <ChevronDown className="h-3.5 w-3.5" aria-hidden />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-40">
            {others.map((type) => (
              <DropdownMenuItem key={type} onClick={() => openCreateWorkItem({ projectId, type })}>
                {workItemTypeLabel(type)}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button type="button" size="sm" className="gap-1.5">
          <Plus className="h-4 w-4" aria-hidden />
          {label}
          <ChevronDown className="h-3.5 w-3.5" aria-hidden />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        {types.map((type) => (
          <DropdownMenuItem
            key={type}
            onClick={() => openCreateWorkItem({ projectId, type })}
          >
            {workItemTypeLabel(type)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
